// extracted by mini-css-extract-plugin
module.exports = {"base":"quickNavigation_base__cNpFZ","wrapper":"quickNavigation_wrapper__leRmM","content":"quickNavigation_content__4NYTI"};